import { __ } from '@wordpress/i18n';
import './style.css';

const { registerPaymentMethod } = window.wc.wcBlocksRegistry;
const { getSetting } = window.wc.wcSettings;
const settings = getSetting( 'dodo_payments_data', {} );

const defaultLabel = __( 'Dodo Payments', 'dodo-payments-for-woocommerce' );
const defaultDescription = __( 'You will be redirected to Dodo Payments to complete your payment securely.', 'dodo-payments-for-woocommerce' );

const Label = ( props ) => {
	const { PaymentMethodLabel } = props.components;

	return <PaymentMethodLabel text={ settings.title || defaultLabel } />;
};

const Content = () => {
	return (
		<div className="dodo-payments-block-content">
			<p>{ settings.description || defaultDescription }</p>
		</div>
	);
};

registerPaymentMethod( {
	name: 'dodo_payments',
	paymentMethodId: 'dodo_payments',
	label: <Label />,
	content: <Content />,
	edit: <Content />,
	canMakePayment: () => true,
	ariaLabel: settings.title || defaultLabel,
	placeOrderButtonLabel: __( 'Proceed to Dodo Payments', 'dodo-payments-for-woocommerce' ),
	supports: {
		features: settings.supports || [ 'products' ],
		showSavedCards: false,
		showSaveOption: false,
	},
} );
